export enum StepperLabel {
    RequesterDetails,
    AddShippingAddress,
    AddChemicalDetails,
    VerifyAndSubmit
  }